import { Size } from "@brightagency/headstart-common";
import { useBreakpoint } from "../../../controllers";

export const useChallengingSitationCardSize = () => {
    const largeBreakpoint = useBreakpoint(Size.large, 50);
    const itemWidth = largeBreakpoint ? 325 : 200;
    const itemGutter = largeBreakpoint ? 16 : 8;

    return {
        itemWidth,
        itemGutter,
        totalItemWidth: itemWidth + itemGutter,
    };
};
